module.exports = __webpack_public_path__ + "static/media/il.81fd85b5.svg";